module.exports = __webpack_public_path__ + "static/media/hb-flat-icon.d4c8141c.png";